var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "toimitustapa" } },
    [
      _c(
        "h2",
        {
          staticClass: "section__heading section__heading--alt2",
          attrs: { id: "shipping-method" }
        },
        [
          _vm._v(
            "\n    3. " + _vm._s(_vm.$modeoL10n.choose_shipping_method) + "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _vm.showError
        ? _c("div", { staticClass: "error-notification" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$modeoL10n.shipping_method_required) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout__rows" },
        [
          _vm._l(_vm.shippingMethodsForView, function(shippingMethod) {
            return [
              _c(
                "div",
                {
                  key: shippingMethod.id + "-label",
                  staticClass: "checkout__header"
                },
                [
                  _c("label", { staticClass: "checkout__header__field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedShippingMethod,
                          expression: "selectedShippingMethod"
                        }
                      ],
                      staticClass: "radio-input",
                      attrs: { type: "radio", name: "shipping_method[0]" },
                      domProps: {
                        value: shippingMethod.id,
                        checked: _vm._q(
                          _vm.selectedShippingMethod,
                          shippingMethod.id
                        )
                      },
                      on: {
                        change: [
                          function($event) {
                            _vm.selectedShippingMethod = shippingMethod.id
                          },
                          function($event) {
                            return _vm.shippingMethodChanged()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "checkout__header__heading radio-label" },
                      [_vm._v(_vm._s(shippingMethod.label))]
                    ),
                    _vm._v(" "),
                    shippingMethod.method_id == "free_shipping"
                      ? _c(
                          "span",
                          { staticClass: "checkout__header__price" },
                          [
                            _c("price", {
                              attrs: {
                                "price-without-tax": shippingMethod.cost,
                                "price-with-tax": shippingMethod.cost_with_tax
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    shippingMethod.method_id != "free_shipping"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "checkout__header__price checkout__header__price--with-tax"
                          },
                          [
                            _c("price", {
                              attrs: {
                                "price-without-tax": shippingMethod.cost,
                                "price-with-tax": shippingMethod.cost_with_tax
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "checkout__header__tax tax" },
                              [
                                _vm._v(
                                  _vm._s(_vm.$modeoL10n.vat) +
                                    " " +
                                    _vm._s(_vm.$store.getters.displayVat)
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "checkout__header__detail" },
                      [
                        shippingMethod.method_id == "free_shipping"
                          ? [
                              _vm._v(
                                _vm._s(_vm.cartDeliveryTime) +
                                  " - " +
                                  _vm._s(_vm.cartDeliveryTime + 1) +
                                  " " +
                                  _vm._s(_vm.$modeoL10n.weeks)
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        shippingMethod.method_id == "flat_rate"
                          ? [
                              _vm._v(
                                _vm._s(_vm.cartDeliveryTime) +
                                  " - " +
                                  _vm._s(_vm.cartDeliveryTime + 1) +
                                  " " +
                                  _vm._s(_vm.$modeoL10n.weeks)
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        shippingMethod.method_id == "local_pickup"
                          ? [
                              _vm._v(
                                _vm._s(_vm.cartDeliveryTime) +
                                  " " +
                                  _vm._s(_vm.$modeoL10n.weeks)
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              shippingMethod.method_id == "free_shipping" &&
              _vm.selectedShippingMethod &&
              _vm.selectedShippingMethod.includes("free_shipping")
                ? _c(
                    "div",
                    {
                      key: shippingMethod.id + "-free-shipping",
                      staticClass: "checkout__subsection"
                    },
                    [
                      _c("div", { staticClass: "grid-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "grid-col bp3-col-one-half" },
                          [
                            _vm.address
                              ? _c(
                                  "p",
                                  [
                                    _vm.address.first_name ||
                                    _vm.address.last_name
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.first_name) +
                                              " " +
                                              _vm._s(_vm.address.last_name)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.company
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.company)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.address_1
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.address_1) +
                                              ",\n              "
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.postcode || _vm.address.city
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.postcode) +
                                              " " +
                                              _vm._s(_vm.address.city)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.phone
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.phone)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.email
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.email) +
                                              "\n              "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout__subsection__form" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "order_comments" } },
                                  [_vm._v(_vm._s(_vm.$modeoL10n.delivery_info))]
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  staticClass: "input-text",
                                  attrs: {
                                    id: "order_comments",
                                    name: "order_comments",
                                    rows: "3"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grid-col bp3-col-one-half" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$modeoL10n.delivery_help1))
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$modeoL10n.delivery_help2))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "checkout__small-print" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$modeoL10n.delivery_help3) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              shippingMethod.method_id == "flat_rate" &&
              _vm.selectedShippingMethod &&
              _vm.selectedShippingMethod.includes("flat_rate")
                ? _c(
                    "div",
                    {
                      key: shippingMethod.id + "-flat-rate",
                      staticClass: "checkout__subsection"
                    },
                    [
                      _c("div", { staticClass: "grid-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "grid-col bp3-col-one-half" },
                          [
                            _vm.address
                              ? _c(
                                  "p",
                                  [
                                    _vm.address.first_name ||
                                    _vm.address.last_name
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.first_name) +
                                              " " +
                                              _vm._s(_vm.address.last_name)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.company
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.company)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.address_1
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.address_1) +
                                              ",\n              "
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.postcode || _vm.address.city
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.postcode) +
                                              " " +
                                              _vm._s(_vm.address.city)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.phone
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.phone)
                                          ),
                                          _c("br")
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.address.email
                                      ? [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.address.email) +
                                              "\n              "
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout__subsection__form" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "order_comments" } },
                                  [_vm._v(_vm._s(_vm.$modeoL10n.delivery_info))]
                                ),
                                _vm._v(" "),
                                _c("textarea", {
                                  staticClass: "input-text",
                                  attrs: {
                                    id: "order_comments",
                                    name: "order_comments",
                                    rows: "3"
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grid-col bp3-col-one-half" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$modeoL10n.delivery_help1))
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$modeoL10n.delivery_help2))
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "checkout__small-print" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$modeoL10n.delivery_help3) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              shippingMethod.method_id == "local_pickup" &&
              _vm.selectedShippingMethod &&
              _vm.selectedShippingMethod.includes("local_pickup")
                ? _c(
                    "div",
                    {
                      key: shippingMethod.id + "-pickup",
                      staticClass: "checkout__subsection"
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$modeoL10n.pickup) +
                            " " +
                            _vm._s(
                              _vm.allProductsAreInOutlet
                                ? _vm.outletWarehouseAddress
                                : _vm.mainWarehouseAddress
                            ) +
                            "."
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9af0da8c", { render: render, staticRenderFns: staticRenderFns })
  }
}